// Agregar un interceptor para incluir el token de autenticación en las solicitudes
import apiClient from "@/api/axios";

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Obtener la lista de usuarios
 * @returns {Promise<Array>} Lista de usuarios
 */
export const getUsers = async () => {
    try {
        const response = await apiClient.get('/admin/users');
        return response.data; // Asumiendo que la API devuelve los usuarios en la propiedad 'data'
    } catch (error) {
        console.error('Error al obtener los usuarios:', error);
        throw error;
    }
};

/**
 * Obtenerusuario
 * @param {String} id id de usuario
 * @returns {Promise<Object>} Usuario
 */
export const getUser = async (id) => {
    try {
        const response = await apiClient.get(`/admin/users/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error al crear el usuario:', error);
        throw error;
    }
};

/**
 * Crear un nuevo usuario
 * @param {Object} user Datos del usuario
 * @returns {Promise<Object>} Usuario creado
 */
export const createUser = async (user) => {
    try {
        const response = await apiClient.post('/admin/users', user);
        return response.data;
    } catch (error) {
        console.error('Error al crear el usuario:', error);
        throw error;
    }
};

/**
 * Crear un nuevo usuario
 * @param {Object} user Datos del usuario
 * @returns {Promise<Object>} Usuario creado
 */
export const createDriver = async (user) => {
    try {
        const response = await apiClient.post('/admin/drivers', user);
        return response.data;
    } catch (error) {
        console.error('Error al crear el usuario:', error);
        throw error;
    }
};

/**
 * Actualizar un usuario existente
 * @param {String} id ID del usuario
 * @param {Object} user Datos actualizados del usuario
 * @returns {Promise<Object>} Usuario actualizado
 */
export const updateUser = async (id, user) => {
    try {
        const response = await apiClient.put(`/admin/users/${id}`, user);
        return response.data;
    } catch (error) {
        console.error('Error al actualizar el usuario:', error);
        throw error;
    }
};

/**
 * Eliminar un usuario
 * @param {String} id ID del usuario
 * @returns {Promise<void>}
 */
export const deleteUser = async (id) => {
    try {
        await apiClient.delete(`/admin/users/${id}`);
    } catch (error) {
        console.error('Error al eliminar el usuario:', error);
        throw error;
    }
};


/**
 * Obtener la lista de choferes
 * @returns {Promise<Array>} Lista de choferes
 */
export const getDrivers = async () => {
    try {
        const response = await apiClient.get('/admin/drivers/available');
        return response.data; // Asumiendo que la API devuelve los usuarios en la propiedad 'data'
    } catch (error) {
        console.error('Error al obtener los usuarios:', error);
        throw error;
    }
};

/**
 * Obtener sugerencia de usuarios en base a un nombre o número de teléfono
 * @param {String} q Nombre o número de teléfono
 * @returns {Promise<Array>} Lista de usuarios
 */
export const getAutocompleteUser = async (q) => {
    try {
        const response = await apiClient.get('/user/autocomplete', {
            params: { q }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener las sugerencias:', error);
        throw error;
    }
}

/**
 * Obtener drivers disponibles
 * @returns {Promise<Array>} Lista de drivers disponibles
 */
export const getAvailableDrivers = async () => {
    try {
        const response = await apiClient.get('/user/drivers/available');
        return response.data;
    } catch (error) {
        console.error('Error al obtener los drivers disponibles:', error);
        throw error;
    }
}

/**
 * Actualizar la contraseña de un usuario
 * @param {String} password Nueva contraseña
 * @param newPassword
 * @returns {Promise<Object>} Respuesta del servidor
 */
export const updatePassword = async (password, newPassword) => {
    try {
        const response = await apiClient.put('/user/update/password', {
            password, newPassword
        });
        return response.data;
    } catch (error) {
        console.error('Error al actualizar la contraseña:', error);
        throw error;
    }
}

/**
 * Actualizar la información del usuario
 * @param {Object} user Datos del usuario
 * @returns {Promise<Object>} Usuario actualizado
 */
export const updateProfile = async (user) => {
    try {
        const response = await apiClient.put('/user/profile', user);
        return response.data;
    } catch (error) {
        console.error('Error al actualizar el usuario:', error);
        throw error;
    }
}

/**
 * Obtener información del usuario actual
 * @returns {Promise<Object>} Información del usuario
 */
export const getUserInfoService = async () => {
    try {
        const response = await apiClient.get('/user/myinfo');
        return response.data;
    } catch (error) {
        console.error('Error al obtener la información del usuario:', error);
        throw error;
    }
}

/**
 * Obtener el tablero del usuario
 * @returns {Promise<Object>} Tablero del usuario
 */
export const getUserDashboard = async () => {
    try {
        const response = await apiClient.get('/user/cdashboard');
        return response.data;
    } catch (error) {
        console.error('Error al obtener el tablero del usuario:', error);
        throw error;
    }
}